//-----------------------------------
// is armour location changed
//-----------------------------------
export default function isArmourLocationChanged(original, now) {
  if (!original || !now) {
    return false
  }

  return original.hp_cur != now.hp_cur
}
